<template>
    <v-form ref="form" v-if="item" @focusout.native="onFieldCommit">
        <eod-workflow-dialog v-if="isStartWorkflowDialogVisible" v-model="isStartWorkflowDialogVisible" :workflow="createWorkflowData" :defaultJobTypeId="createWorkflowJobTypeId" :defaultProductId="createWorkflowProductId" :defaultTaskTypeConfigId="createWorkflowTaskTypeConfigId" @saved="newWorkflowSaved"></eod-workflow-dialog>
        <v-card-title v-if="!hideHeader">{{ item.name }}
            <v-btn v-if="item.id" target="_blank" :to="{name:'dashboard.product', params:{id:item.id}}" class="ml-4" depressed rounded color="gray" small><v-icon left small>mdi-view-dashboard-outline</v-icon>Dashboard</v-btn>
            
            <template v-if="item.id && item.productType?.taskTypeConfig?.[0]">
                
                <v-btn color="secondary" v-if="item.productType.taskTypeConfig.length == 1" @click="startWorkflow(item.productType?.taskTypeConfig?.[0])" class="ml-4" depressed rounded small><v-icon left small>mdi-plus</v-icon>Workflow starten</v-btn>
                <v-menu v-else offset-y>
                    <template v-slot:activator="{on, attrs}">
                        <v-btn v-on="on" v-bind="attrs" class="ml-4" depressed rounded color="secondary" small><v-icon left small>mdi-plus</v-icon>Workflow starten</v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item @click="startWorkflow(config)" v-for="config in item.productType.taskTypeConfig" :key="config.id">
                            <v-list-item-title>{{ config.taskType.name }} ({{ config.jobType.name }})</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
            <v-spacer></v-spacer>
        </v-card-title>
        <template v-if="!['DEVICE_FOLDER'].includes(item.class)">
        <v-card-text>
            <v-tabs v-model="selectedtab">
                <v-tab>Algemeen</v-tab>
                <v-tab>Media</v-tab>
                <v-tab>Locatie</v-tab>
                <v-tab v-if="item.id">Historiek</v-tab>
                <v-tab v-if="!hideMeasurementTypes">Instellingen</v-tab>
                
            </v-tabs>
            </v-card-text>
            <v-card-text>
                <!-- Verplichte-velden-feedback verloopt via $toaster.notify (rode melding rechtsboven, zie saveItem) -->
                
            
            
                
        <v-tabs-items :value="selectedtab">
      <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
        <v-row>
            <v-col cols="12" :lg="8" :xl="9">
                    <v-row>
                    <v-col cols="12" :lg="6">
                        <v-text-field
                            v-model="item.name"
                            :rules="[val => $validator.required(val, 'Naam')]"
                            label="Naam*"
                            required
                            outlined
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" :lg="6">
                        <v-text-field
                            v-model="item.description"
                            label="Omschrijving"
                            outlined
                            hide-details
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" :xl="6">
                        <eod-object-autocomplete :default-filter="{whereIn:[{column:'class',array:[item.class]}]}" :fields="['id', 'name', 'customFields{customFieldId, module, itemId, value}', 'taskTypeConfig{id taskType{id name} jobType{id name}}']" dense hide-details :rules="[val => $validator.required(val, 'Type')]" label="Type*" endpoint="productTypes" :key="typeSelectKey" :value="item.productType?item.productType.id:null" @input="productTypeChanged" required>
                            <template v-slot:append-item>
                                <v-divider></v-divider>
                                <v-list-item dense @click="isCreateTypeDialogVisible = true">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Type toevoegen</v-list-item-title>
                                        <v-list-item-subtitle>Voeg een type toe wanneer u deze
                                            niet in de lijst vindt.</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </eod-object-autocomplete>
                        <eod-dialog title="Type toevoegen" icon="mdi-plus" iconColor="primary" v-if="isCreateTypeDialogVisible" v-model="isCreateTypeDialogVisible" @okAction="createProductType" okText="Toevoegen" width="800">
                            <v-form ref="productTypeForm">
                                <v-alert type="error" v-if="typeFormErrors[0]" dense class="mt-2">
                                    <ul>
                                        <li v-for="(error, index) in typeFormErrors" :key="index">{{ error }}</li>
                                    </ul>
                                </v-alert>
                                <eod-product-type-detail class="mt-4" v-model="newProductType"></eod-product-type-detail>
                            </v-form>
                        </eod-dialog>
                        <v-dialog v-model="typeChangeDialog" max-width="600" persistent>
                            <v-card>
                                <v-card-title>
                                    <v-avatar color="warning" size="40" class="elevation-3 mr-4"><v-icon dark>mdi-alert</v-icon></v-avatar>
                                    <span class="headline">Asset type wijzigen</span>
                                </v-card-title>
                                <v-card-text class="pt-4">
                                    Je wijzigt het asset type. Instellingen (custom velden) die <strong>gedeeld</strong> zijn met het nieuwe type blijven behouden; velden die niet bij het nieuwe type horen worden niet meer getoond.
                                </v-card-text>
                                <v-card-actions class="grey lighten-3 py-3 px-3">
                                    <v-spacer></v-spacer>
                                    <v-btn text rounded @click="cancelProductTypeChange">Annuleren</v-btn>
                                    <v-btn color="warning" depressed rounded @click="applyProductTypeChange(pendingTypeId)">Doorgaan</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-col>
                    <v-col cols="12" :lg="6">
                        <eod-objects-treeview-input :classes="['COMPANY','PROJECT',item.class+'_FOLDER', item.class]" :rules="[val => $validator.required(val, 'Bovenliggend item')]" required v-model="item.treeParentId" @input="parentChanged" :exclude="item.id?[item.id]:null" label="Bovenliggend item*">
                            <template v-slot:append-item>
                                <v-divider></v-divider>
                                <v-list-item dense @click.stop="isCreateProjectDialogVisible = true">
                                    <v-list-item-icon>
                                        <v-icon>mdi-plus</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Nieuw project aanmaken</v-list-item-title>
                                        <v-list-item-subtitle>Maak een project aan wanneer u het niet in de lijst vindt.</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </eod-objects-treeview-input>
                        <eod-dialog v-if="isCreateProjectDialogVisible" v-model="isCreateProjectDialogVisible" :loading="isCreateProjectDialogLoading" title="Project toevoegen" icon="mdi-plus" iconColor="primary" width="1200" @okAction="createProject" okText="Toevoegen">
                            <v-form ref="projectForm">
                                <eod-project-detail class="mt-4" outlined compact v-model="newProject"></eod-project-detail>
                            </v-form>
                        </eod-dialog>
                    </v-col>
                    <v-col cols="12" :lg="6">
                        <eod-object-autocomplete :default-filter="item.company ? {where:[{column:'companyId', value:item.company.id}]} : {}" dense hide-details :rules="[val => $validator.required(val, 'Dienst')]" label="Dienst*" endpoint="services" v-model="item.serviceId" required></eod-object-autocomplete>
                    </v-col>
                </v-row>
                <v-row v-if="item.productType && item.productType.id">
                    <v-col>                        
                        <eod-product-type-preview :value="item.productType.id"></eod-product-type-preview>
                    </v-col>
                </v-row>
                        <v-text-field
                            v-model="item.code"
                            label="Serienummer"
                            outlined
                            hide-details
                            dense
                            class="mt-4 mb-4"
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" :lg="4" :xl="3">
                    <v-img width="200" max-height="280" :src="qr_code" aspect-ratio="1" contain class="mx-auto"/>
                </v-col>
                        </v-row>
                        <template v-if="item.latestWorkflows && item.latestWorkflows.length > 0">
                        <div class="d-flex align-center mb-2">
                        <v-label>Laatste activiteiten <v-tooltip bottom><template v-slot:activator="{on, attrs}"><v-icon small v-on="on" v-bind="attrs">mdi-information</v-icon></template>Overzicht van recente activiteiten per type workflow in uitvoering of uitgevoerd (geplande items worden niet weergegeven)</v-tooltip></v-label>
                        <v-spacer></v-spacer>
                        <eod-btn @click="selectedtab = 3" small text>Bekijk volledige historiek</eod-btn>
                        </div>
                        <eod-card class="mb-4" outlined>
                            <eod-product-history @startWorkflow="startWorkflowFromHistory" @loaded="productHistoryLoaded" :headers="productHistoryHeaders" @filter="filterHistory" hide-search :items="item.latestWorkflows"></eod-product-history>
                        </eod-card>
                    </template>
                <eod-custom-fields-item v-if="item.productType" :key="item.productType.id" :defaultValues="customFieldsDefaultValues" v-model="item.customFields" endpoint="products" :id="item.id" :extraFields="item.productType && item.productType.id?[{module:'productTypes', id: item.productType.id}]:null"></eod-custom-fields-item>
                <v-row>
                    <v-col cols="12" :xl="4">
                        <v-menu
                            ref="installedDateMenu"
                            v-model="datepickers.installedDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="item.installedDateFormatted"
                                label="Installatiedatum"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                hide-details
                                dense
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="item.installedDateFormatted" no-title scrollable @input="datepickers.installedDate = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col cols="12" :xl="4">
                        <v-menu
                            ref="warrantyEndDateMenu"
                            v-model="datepickers.warrantyEndDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="item.warrantyEndDateFormatted"
                                label="Vervaldatum garantie"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                hide-details
                                dense
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="item.warrantyEndDateFormatted" no-title scrollable @input="datepickers.warrantyEndDate = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <!-- <v-col cols="12" :xl="4">
                        <v-menu
                            ref="lastMaintenanceDateMenu"
                            v-model="datepickers.lastMaintenanceDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="item.lastMaintenanceDateFormatted"
                                label="Laatste onderhoud"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                hide-details
                                dense
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="item.lastMaintenanceDateFormatted" no-title scrollable @input="datepickers.lastMaintenanceDate = false"></v-date-picker>
                        </v-menu>
                    </v-col> -->
                </v-row>
                <v-row>
                    <v-col>                        
                        <eod-text-field label="Hardware ID" v-model="item.hardwareId"></eod-text-field>
                    </v-col>
                </v-row>
                 <v-row>
                    <v-col cols="12" :xl="4">
                        <eod-list-item-autocomplete dense outlined v-if="$eod.getOrganizationSetting('products.statusCode.listId')" v-model="item.statusCode.id" label="Status code" :listId="$eod.getOrganizationSetting('products.statusCode.listId').value"></eod-list-item-autocomplete>
                    </v-col>
                    <v-col cols="12" :xl="4">
                        <eod-color-picker label="Kleur" v-model="item.color" dot-size="15" hide-mode-switch mode="hexa"></eod-color-picker>
                    </v-col>
                </v-row>
        </v-tab-item>
      <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
        <eod-storage-library v-if="item.id" :searchable="!hideStorageSearch" :tags="{ productId: item.id }" :searchFilters="[{ field: 'productId', name: item.name, value: item.id }]"></eod-storage-library>
        <v-alert v-else type="info" text dense>Gelieve asset eerst te bewaren om media te kunnen toevoegen</v-alert>
      </v-tab-item>
      <v-tab-item transition="expand-transition" reverse-transition="expand-transition">
        <eod-autocomplete :items="[{value:null, text:'Overnemen van project'}, {value: {}, text: 'Verschillend van project'}]" :value="item.location == null?null:{}" @input="setLocation" class="mb-4"></eod-autocomplete>
        <v-row v-if="item.location">
            <v-col cols="12" md="4">
                <eod-card class="overflow-hidden">
                    <eod-location-form :key="mapUpdate" v-model="item" :filters="{where:[{column:'productId', value:item.id}]}"></eod-location-form>
                </eod-card>
            </v-col>
            <v-col cols="12" md="8">
                <eod-card outlined>
              <v-card-text>
                <v-text-field class="mb-4" id="input_find_address" v-model="search" type="search" solo outlined dense rounded label="Zoek een adres..." @keyup="searchKeyUp">
                    <template v-slot:append-outer>
                        <v-btn :loading="searching" color="primary" style="margin-top:-7px;margin-bottom:-4px;" fab x-small @click="searchAddress"><v-icon>mdi-magnify</v-icon></v-btn>
                    </template>
                </v-text-field>
                <v-row>
                    <v-col cols="12">
                        <eod-text-field
                            v-model="item.location.streetAddress"
                            label="Straat + nummer"></eod-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <eod-text-field v-model="item.location.postalCode"
                            label="Postcode"></eod-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <eod-text-field  v-model="item.location.locality"
                            label="Stad/Gemeente"></eod-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <eod-text-field v-model="item.location.region"
                            label="Regio"></eod-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <eod-text-field v-model="item.location.country" 
                            label="Land"></eod-text-field>
                    </v-col>
                </v-row>
              </v-card-text>
          </eod-card>
            </v-col>
            
        </v-row>
        <v-row v-if="!item.location && item.project && item.project.locations && item.project.locations[0]">
            <v-col cols="12" :md="8">
                <v-card>
              <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <eod-text-field disabled
                            :value="item.project.locations[0].streetAddress"
                            label="Straat + nummer"></eod-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <eod-text-field disabled :value="item.project.locations[0].postalCode"
                            label="Postcode"></eod-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <eod-text-field disabled  :value="item.project.locations[0].locality"
                            label="Stad/Gemeente"></eod-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <eod-text-field disabled :value="item.project.locations[0].region"
                            label="Regio"></eod-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <eod-text-field disabled :value="item.project.locations[0].country" 
                            label="Land"></eod-text-field>
                    </v-col>
                </v-row>
              </v-card-text>
          </v-card>
            </v-col>
            <v-col cols="12" md="4">
                <v-card class="overflow-hidden">
                    <eod-location-form disabled :value="item.project.locations[0]"></eod-location-form>
                </v-card>
            </v-col>
        </v-row>
          
      </v-tab-item>
      <v-tab-item v-if="item.id" transition="expand-transition" reverse-transition="expand-transition">
        <eod-product-history @startWorkflow="startWorkflowFromHistory" :headers="productHistoryHeaders" @loaded="productHistoryLoaded" :filter="{where:[{column:'productId', value:item.id}]}" :search="productHistorySearch"></eod-product-history>
        </v-tab-item>
      <v-tab-item transition="expand-transition" reverse-transition="expand-transition" v-if="!hideMeasurementTypes">
      <eod-measurement-type-indicative show-hardware-id v-model="item.measurementTypes"></eod-measurement-type-indicative>
    </v-tab-item>
        </v-tabs-items>
    </v-card-text>
</template>
    <v-card-text v-else-if="['DEVICE_FOLDER'].includes(item.class)">
        <v-text-field label="Naam" dense outlined v-model="item.name"></v-text-field>
        <eod-objects-treeview-input :classes="['COMPANY','PROJECT',item.class+'_FOLDER', item.class]" :rules="[val => $validator.required(val, 'Bovenliggend item')]" required v-model="item.treeParentId" :exclude="item.id?[item.id]:null" label="Bovenliggend item*"></eod-objects-treeview-input>
    </v-card-text>
</v-form>
</template>
<script>
import eodMeasurementTypeIndicative from './eod-measurementType-indicative.vue';
import eodColorPicker from './eod-color-picker.vue';
import eodListItemAutocomplete from './eod-list-item-autocomplete.vue';
import eodObjectAutocomplete from './eod-object-autocomplete.vue';
import eodStorageLibrary from './eod-storage-library.vue';
import eodLocationForm from './eod-location-form.vue';
import eodObjectsTreeviewInput from './eod-objects-treeview-input.vue';
import eodProductTypePreview from './eod-product-type-preview.vue';
import eodProductTypeDetail from './eod-product-type-detail.vue';
import eodCustomFieldsItem from './eod-custom-fields-item.vue'
import Product from './../models/product.js';
import Project from './../models/project.js';
import eodProductHistory from './eod-product-history.vue';
import EodAlarmList from './eod-alarm-list.vue';
import EodBtn from './eod-btn.vue';
import eodWorkflowDialog from './eod-workflow-dialog.vue';
import { VAlert, VIcon, VTooltip } from 'vuetify/lib';

export default{
    name: 'eod-product-detail',
    components:{
        eodMeasurementTypeIndicative,
        eodColorPicker,
        eodListItemAutocomplete,
        eodObjectAutocomplete,
        eodStorageLibrary,
        eodLocationForm,
        eodObjectsTreeviewInput,
        eodProductTypePreview,
        eodProductTypeDetail,
        eodCustomFieldsItem,
        eodProductHistory,
        EodAlarmList,
        EodBtn,
        VIcon,
        VAlert,
        VTooltip,
        eodWorkflowDialog,
        // Async: eod-project-detail importeert (via de treeview) dit component terug.
        eodProjectDetail: () => import('./eod-project-detail.vue'),
    },
    props:{
        value: String|Object,
        hideHeader: Boolean,
        hideMeasurementTypes: Boolean,
        hideStorageSearch: Boolean,
        hideSave: Boolean,
    },
    data: () => ({
        isStartWorkflowDialogVisible: false,
        createWorkflowData: null,
        createWorkflowProductId: null,
        createWorkflowJobTypeId: null,
        productHistorySearch: null,
        productHistoryHeaders: [
            {
                value:'taskType',
                text: 'Workflow'
            },
            {
                value:'plan',
                text: 'Planningsdatum'
            },
            {
                value:'reportedAt',
                text: 'Uitvoeringsdatum'
            },
            {
                value:'responsibleUsers',
                text: 'Uitvoerders'
            },
            {
                value:'statusCode',
                text: 'Status',
                width: 100
            },
            {
                value:'actions',
                align: 'end',
                sortable: false,
                width: 100
            }
        ],
        item: null,
        loading: false,
        saving: false,
        creating: false,
        savingTimeout: null,
        resolvingParent: false,
        isCreateAlarmDialogVisible: false,
        errors: null,
        missingFieldsToast: null,
        selectedtab: 'general',
        datepickers: {
            warrantyEndDate: false,
            installedDate: false,
            lastMaintenanceDate: false,
        },
        qr_code: null,
        isCreateTypeDialogVisible: false,
        typeChangeDialog: false,
        pendingTypeId: null,
        typeSelectKey: 0,
        newProductType: {},
        isCreateProjectDialogVisible: false,
        isCreateProjectDialogLoading: false,
        newProject: {},
        typeFormErrors: [],
        customFieldsDefaultValues: [],
        newAlarmTemplate: null,

        search: null,
        searching: false,

        mapUpdate: 3543
    }),
    created(){
        if(this.value){
            if(typeof this.value == 'string'){
                this.loadItem(this.value);
            }else{
                this.item = this.value;
                this.$emit('loaded', this.item);

                // Bovenliggend item al ingevuld (bv. asset toevoegen in de tree) →
                // project/bedrijf/dienst meteen afleiden zonder dat de gebruiker de
                // parent opnieuw moet kiezen. Onderdruk de autosave tijdens dit afleiden
                // (resolvingParent), anders triggert het zetten van project/dienst een
                // premature autosave op het nog lege formulier → valse 'verplichte velden'-melding.
                if(this.item && this.item.treeParentId && !this.item.id){
                    this.resolvingParent = true;
                    this.deriveParentContext(this.item.treeParentId).finally(() => {
                        this.resolvingParent = false;
                    });
                }

                this.generateQRCode();

                if(this.$eod.getOrganizationSetting('products.statusCode.listId') && this.$eod.getOrganizationSetting('products.statusCode.listId').value){
                        this.$eod.get('listItems', ['id', 'name', 'threshold'], {
                            orderBy:{
                                "column": "name",
                                "type": "ASC"
                            },
                            where: [
                                {
                                    column: 'listId',
                                    operator: '=',
                                    value: this.$eod.getOrganizationSetting('products.statusCode.listId').value
                                },
                                {
                                    column: 'threshold',
                                    operator: '=',
                                    value: '1'
                                }
                            ]
                        }).then(response => {
                            if(response.data.data.listItems && response.data.data.listItems.edges && response.data.data.listItems.edges[0]){
                                this.item.statusCode = response.data.data.listItems.edges[0];
                            }
                        })
                    }
                
            }
        }
    },
    watch:{
        loading(val){
            this.$emit('loading', val);
        },
        item: {
            deep: true,
            handler() {
                // Wis banner én inline veldfouten meteen bij elke wijziging, zodat
                // ze niet blijven hangen en de invulvelden niet wegduwen tijdens
                // het typen. Ze verschijnen pas terug na de korte pauze (debounce)
                // hieronder, als er dan nog iets ontbreekt.
                this.errors = null;
                if (this.$refs.form) { this.$refs.form.resetValidation(); }
                clearTimeout(this.savingTimeout);
                // Niet autosaven terwijl een wijziging van bovenliggend item nog
                // resolvet: serviceId is dan tijdelijk leeg, wat anders een valse
                // validatiefout zou opleveren.
                if (this.loading || this.resolvingParent) {
                    return;
                }
                // Autosave draait 500ms na de laatste toetsaanslag (= pauze) en
                // toont dan enkel de banner met ontbrekende velden, niet de inline
                // rode meldingen (saveItem(false)). Een NIEUW asset (nog geen id) niet
                // tijdens het typen aanmaken (voorkomt meerdere onvolledige duplicaten,
                // #297): pas createn op een commit-moment (focusout, zie onFieldCommit)
                // of — als vangnet — na langere inactiviteit.
                const isNew = !this.item.id;
                this.savingTimeout = setTimeout(
                    () => (isNew ? this.onFieldCommit() : this.saveItem(false)),
                    isNew ? 1000 : 500,
                );
            }
        }
    },
    methods:{
        async loadItem(itemId){
            this.loading = true;
                
                return this.$eod.getById('product', itemId, ['id', 'latestWorkflows{response{id} company{id name} project{id name} parentTask{id name project{id name} company{id name} service{id name} taskType{id name}} taskType{id name} jobType{id name} dueAfterDate dueBeforeDate reportedAt responsibleUsers{id} statusCode}','customFields{customFieldId, module, itemId, value}', 'company{id}', 'service{id}', 'name', 'treeParentId', 'hardwareId', 'project{id name locations{name description streetAddress postalCode locality region country lat lon}}', 'description', 'color', 'productType{id taskTypeConfig{id taskType{id name} jobType{id name}}}', 'code', 'class', 'warrantyEndDate', 'installedDate', 'lastMaintenanceDate', 'statusCode{id}', 'measurementTypes{id name unit{id name} settings{id, starttime, endtime, value} hardwareId}', 'lat','lon', 'locationParent', 'location{name description streetAddress postalCode locality region country}'])
                    .then(response => {
                        if(response && response.data.data && response.data.data.product){
                            this.item = new Product(response.data.data.product);
                        }else{
                            this.item = null;
                        }

                        if(this.item && !this.item.statusCode){
                            this.item.statusCode = {};
                        }

                        this.loadProductTypeCustomFields();
                        this.generateQRCode();
                        this.$emit('loaded', this.item);
                    }).finally(() => {
                        this.loading=false;
                    });
        },
        startWorkflowFromHistory(item){
            this.createWorkflowTaskTypeConfigId = null;
            this.createWorkflowProductId = this.item.id;
            this.createWorkflowJobTypeId = item.jobType?.id || null;
            this.createWorkflowData = {
                project: this.item.project,
                company: this.item.company,
                service: {id:this.item.serviceId},
                taskTypeId: item.taskType.id
            }

            this.isStartWorkflowDialogVisible = true;
        },
        productHistoryLoaded(items){
            let isProjectColumnVisible = false;
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if(item.project && this.item.project && item.project.id != this.item.project.id){
                    isProjectColumnVisible = true;
                }
            }

            if(isProjectColumnVisible && this.productHistoryHeaders[this.productHistoryHeaders.length-3].value !== 'project'){
                this.productHistoryHeaders.splice(this.productHistoryHeaders.length-2, 0, {
                    value:'project',
                    text: 'Project'
                });
            } else if (!isProjectColumnVisible && this.productHistoryHeaders[this.productHistoryHeaders.length-3].value === 'project'){
                this.productHistoryHeaders.splice(this.productHistoryHeaders.length-3, 1);
            }
        },
        filterHistory(key, value){
            this.productHistorySearch = [{key: key, value: value}];
            this.selectedtab = 3;
        },
        startWorkflow(config){
            this.createWorkflowJobTypeId = null;
            this.createWorkflowProductId = this.item.id;
            this.createWorkflowTaskTypeConfigId = config.id;
            this.createWorkflowData = {
                project: this.item.project,
                company: this.item.company,
                service: {id:this.item.serviceId},
            }

            this.isStartWorkflowDialogVisible = true;
        },
        newWorkflowSaved(){
            this.$toaster.notify({
                        type: 'success',
                        title: this.$t('Succes'),
                        body: this.$t('Workflow succesvol gestart')
                    });
            this.isStartWorkflowDialogVisible = false;
        },
        generateQRCode(){
            // QR code
            if(this.item.id){
                this.$helper.generateQR('asset', this.item.id).then(result => {
                    this.qr_code = result;
                });
            }
        },
        searchKeyUp(event){
            if(event && event.key && event.key.toLowerCase() == 'enter'){
                this.searchAddress();
            }
        },
        searchAddress(){
            this.searching = true;

            this.$helper.geocode(this.search).then(response => {
                if(response.address){
                    this.updatePosition(response.lat, response.lon);
                    this.updateLocation(response.address);
                }                
            }).finally(() => {
                this.searching = false;
            });
        },
        setLocation(location){
            if(!location){
                this.item.location = null;
                this.item.lat = null;
                this.item.lon = null;
            } else {
                this.item.location = {};
            }
            this.$forceUpdate();
        },
        loadProductTypeCustomFields(){
            this.$nextTick(() => {
                this.customFieldsDefaultValues = null;
                if(this.item && this.item.productType){
                    this.$eod.getById('productType', this.item.productType.id, ['id','customFields{customFieldId, module, itemId, value}'])
                        .then(response => {
                            if(response.data && response.data.data && response.data.data.productType){
                                this.customFieldsDefaultValues = response.data.data.productType.customFields;
                                this.$forceUpdate();
                            }
                        });
                }
            });
        },
        productTypeChanged(typeId) {
            if(!typeId || (this.item.productType && this.item.productType.id == typeId)){
                return;
            }

            // #1275: waarschuw bij een type-wissel wanneer er al custom-veld-waarden zijn.
            // Gedeelde velden (zelfde customFieldId, geldig op beide types) behouden hun waarde;
            // velden die niet bij het nieuwe type horen worden niet meer getoond.
            if (this.item.customFields && this.item.customFields.length > 0) {
                this.pendingTypeId = typeId;
                this.typeChangeDialog = true;
                return;
            }

            this.applyProductTypeChange(typeId);
        },
        applyProductTypeChange(typeId) {
            this.typeChangeDialog = false;
            this.pendingTypeId = null;

            // Reactieve toewijzing (Vue 2): `productType.id` zetten op een leeg object ({}) is
            // geen reactieve mutatie (nieuwe property), waardoor het Type-veld (:value + validatie)
            // stale bleef en "Type is verplicht" toonde ondanks een gekozen type. Vervang daarom
            // het hele object zodat de reactiviteit (en de autosave-watch) wel triggert.
            this.item.productType = { ...(this.item.productType || {}), id: typeId };

            // #1275: customFields NIET wissen — gedeelde velden behouden zo hun waarde (gematcht
            // op customFieldId). Niet-gedeelde velden worden simpelweg niet gerenderd voor het
            // nieuwe type.
            this.loadProductTypeCustomFields();
        },
        cancelProductTypeChange() {
            this.typeChangeDialog = false;
            this.pendingTypeId = null;
            // Herstel het Type-veld naar het huidige (ongewijzigde) type.
            this.typeSelectKey++;
        },
        updatePosition(lat, lon){
            if(lat || lon){
                this.item.lat = lat?parseFloat(lat):null;
                this.item.lon = lon?parseFloat(lon):null;
            }
            this.mapUpdate++;
        },
        updateLocation(address){

            if(!address){
                return false;
            }

            if(address.road){
                this.item.location.streetAddress = address.road;

                if(address.house_number){
                    this.item.location.streetAddress += ' ' + address.house_number;
                }
            }
            
            if(address.country){
                this.item.location.country = address.country;
            }

            if(address.city){
                this.item.location.locality = address.city;
            }
            if(address.town){
                this.item.location.locality = address.town;
            }
            if(address.village){
                this.item.location.locality = address.village;
            }
            
            if(address.postcode){
                this.item.location.postalCode = address.postcode;
            }

            if(address.state){
                this.item.location.region = address.state;
            }
        },
        async parentChanged(parentId){
            // Onderdruk autosave tijdens het resolven van het nieuwe bovenliggende
            // item. serviceId wordt eerst geleegd en pas na de async lookups terug
            // ingevuld; zonder deze guard zou een autosave in dat venster een valse
            // 'verplichte velden'-melding tonen.
            this.resolvingParent = true;
            try {
                await this.deriveParentContext(parentId);
            } finally {
                this.resolvingParent = false;
                // Eén autosave nu het bovenliggende item, project en dienst resolved zijn.
                if (!this.loading) {
                    clearTimeout(this.savingTimeout);
                    // Nieuw asset: nog niet aanmaken tijdens het typen (#297) — via het
                    // commit-moment (onFieldCommit); bestaand asset autosavet meteen.
                    const isNew = !this.item.id;
                    this.savingTimeout = setTimeout(
                        () => (isNew ? this.onFieldCommit() : this.saveItem(false)),
                        isNew ? 2500 : 500,
                    );
                }
            }
        },
        // Leidt project/bedrijf/dienst af uit de parent-keten en vult de standaard-dienst
        // in met prioriteit project → bedrijf → manueel. Geen autosave, zodat dit ook bij
        // init herbruikt kan worden (bovenliggend item al ingevuld, bv. toevoegen in de tree).
        async deriveParentContext(parentId){
            this.item.project = null;
            this.item.serviceId = null;
            if(!parentId){ return; }

            const response = await this.$eod.getById('treeObject', parentId, ['id','class', 'parents{id name class}']);
            if(response.data.data && response.data.data.treeObject){
                const toCheck = [response.data.data.treeObject];
                if( Array.isArray(response.data.data.treeObject.parents)){
                    toCheck.push(...response.data.data.treeObject.parents);
                    let projectServiceId = null;
                    let companyServiceId = null;
                    for (let i = 0; i < toCheck.length; i++) {
                        const parent = toCheck[i];
                        if(parent.class == 'PROJECT'){
                            const projectResponse = await this.$eod.getById('project', parent.id, ['id', 'name', 'defaultService{id}','locations{name description streetAddress postalCode locality region country lat lon}']);
                            if(projectResponse.data.data && projectResponse.data.data.project){
                                this.item.project = projectResponse.data.data.project;
                                if(projectResponse.data.data.project.defaultService){
                                    projectServiceId = projectResponse.data.data.project.defaultService.id;
                                }
                            }
                        } else if (parent.class == 'COMPANY'){
                            const companyResponse = await this.$eod.getById('company', parent.id, ['id', 'defaultService{id}', 'name','locations{name description streetAddress postalCode locality region country lat lon}']);
                            if(companyResponse.data.data && companyResponse.data.data.company){
                                this.item.company = companyResponse.data.data.company;
                                if(companyResponse.data.data.company.defaultService){
                                    companyServiceId = companyResponse.data.data.company.defaultService.id;
                                }
                                this.$forceUpdate();
                            }
                        }
                    }
                    // Standaard-dienst: prioriteit project → bedrijf → manueel kiezen
                    this.item.serviceId = projectServiceId || companyServiceId || null;
                    this.$forceUpdate();
                }
            }
        },
        // #1464 — Project aanmaken vanuit 'Bovenliggend item' en het meteen als
        // parent instellen, zodat de gebruiker op een lege omgeving niet vastloopt.
        async createProject(){
            if(this.$refs.projectForm && !this.$refs.projectForm.validate()){
                return false;
            }

            this.isCreateProjectDialogLoading = true;
            const saveData = (new Project(this.newProject)).getSaveData();
            const newProjectId = await this.$eod.save('Project', saveData).then(response => {
                if(response && response.data && response.data.data && response.data.data.createProject){
                    return response.data.data.createProject.id;
                }
                return null;
            }).catch(() => null);
            this.isCreateProjectDialogLoading = false;

            if(newProjectId){
                this.isCreateProjectDialogVisible = false;
                this.newProject = {};
                this.item.treeParentId = newProjectId;
                this.parentChanged(newProjectId);
            }
        },
        createProductType(){
            if(this.$refs.productTypeForm){
                const valid = this.$refs.productTypeForm.validate();

                if(!valid){
                    this.typeFormErrors = [];
                    this.$refs.productTypeForm.inputs.forEach(e => {
                        if (e.errorBucket && e.errorBucket.length) {
                            this.typeFormErrors.push(...e.errorBucket);
                        }
                    });

                    return false;
                }

                this.$eod.save('ProductType', this.newProductType).then((response) => {
                    if(response.data && response.data.data && response.data.data.createProductType){
                        this.item.productType = response.data.data.createProductType;
                        this.isCreateTypeDialogVisible = false;
                        this.newProductType = {};
                    }
                });
            }
        },
        getFormErrors() {
            const errors = [];
            this.$refs.form.inputs.forEach(e => {
                if (e.errorBucket && e.errorBucket.length) {
                    errors.push(...e.errorBucket);
                }
            });
            return errors;
        },
        onFieldCommit() {
            // Commit-moment voor een nog niet aangemaakt asset: veld verlaten (blur) of
            // langere pauze. Pas dán aanmaken, en enkel als het formulier geldig is — zo
            // ontstaan er geen tussentijdse, onvolledige duplicaten (#297). Stille check:
            // bij een onvolledig formulier nog niet aanmaken en niet zeuren.
            if (this.loading || this.resolvingParent || this.saving || this.creating) return;
            if (this.item.id || !this.$refs.form) return;
            if (!this.$refs.form.validate()) {
                this.$refs.form.resetValidation();
                return;
            }
            clearTimeout(this.savingTimeout);
            this.saveItem(false);
        },
        async saveItem(showInlineErrors = true){
            if(!this.$refs.form){
                return false;
            }

            try {
                const validation = this.$refs.form.validate();
                if(!validation){
                    // Toon de ontbrekende verplichte velden als rode toaster-melding
                    // (zelfde locatie/stijl als de andere notificaties, vb. "Workflow
                    // succesvol gestart"), ook voor een nieuw product. Eén melding per
                    // invalide-reeks — niet bij elke toetsaanslag.
                    const formErrors = this.getFormErrors();
                    if(formErrors.length && !this.missingFieldsToast){
                        // Blijft staan tot het formulier geldig is of de gebruiker erop klikt.
                        this.missingFieldsToast = this.$toaster.notify({
                            type: 'danger',
                            timeout: 0,
                            title: 'Gelieve verplichte velden in te vullen',
                            body: formErrors.join('<br>'),
                            onClose: () => { this.missingFieldsToast = null; }
                        });
                    }
                    if(!showInlineErrors){
                        // Geen inline rode meldingen die de invulvelden wegduwen.
                        this.$refs.form.resetValidation();
                    }
                    return false;
                }

                // Voorkom dubbele aanmaak: als er voor dit nieuwe asset al een create
                // onderweg is, niet nog eens aanmaken (anders ontstaan duplicaten).
                const isNew = !this.item.id;
                if(isNew && this.creating){
                    return false;
                }
                // Sluit een eventuele openstaande "verplichte velden"-melding; bij een
                // geslaagde opslag komt er een groene bevestiging in de plaats.
                const hadMissingToast = !!this.missingFieldsToast;
                if(this.missingFieldsToast){ this.missingFieldsToast(true); this.missingFieldsToast = null; }
                this.errors = null;
                this.saving = true;
                if(isNew){ this.creating = true; }
                this.$emit('saving', true);

                const data = (new Product(this.item)).getSaveData();
                const response = await this.$eod.save('Product', data);
                if(response && response.data && response.data.data){
                    if(response.data.data.createProduct){
                        await this.loadItem(response.data.data.createProduct.id);
                        this.$emit('saved', this.item);
                        // Apart 'created'-event zodat de tree enkel na een AANMAAK herlaadt
                        // (niet bij elke autosave-update), zie eod-objects-treeview-detail.
                        this.$emit('created', this.item);
                        const route = this.$router.resolve({name: 'products', query:{'productIds[]':this.item.id}});
                        window.history.pushState({}, null, route.route.fullPath);
                        this.$toaster.notify({ type: 'success', title: 'Asset succesvol aangemaakt' });
                        //return response.data.data.createProduct.id;
                    }else if (response.data.data.updateProduct){
                        this.item.id = response.data.data.updateProduct.id;
                        this.$emit('saved', this.item);
                        // Groene bevestiging enkel wanneer er net nog een "verplichte
                        // velden"-melding stond (dus na het oplossen); gewone autosaves
                        // blijven stil (de "Bewaard om"-chip volstaat daar).
                        if(hadMissingToast){ this.$toaster.notify({ type: 'success', title: 'Asset succesvol aangepast' }); }
                        //return response.data.data.updateProduct.id;
                    }
                }
                return false;
            } catch (e) {
                // Code-/runtimefouten (mislukte request, fout in getSaveData, ...) mogen
                // de autosave niet stukmaken: log ze en herstel de status hieronder,
                // zodat de volgende wijziging gewoon opnieuw een autosave triggert.
                console.error('Autosave van product mislukt:', e);
                return false;
            } finally {
                this.saving = false;
                this.creating = false;
                this.$emit('saving', false);
            }
        },
    }
}
</script>